import React from "react";

export const MoveItemHelp = () => {
  return (
    <div>
      <h1>Move Item Help</h1>
    </div>
  );
};

export default MoveItemHelp;
